

export function TextAtom({title, className, style, onClick}) {


    return(
        <p onClick={onClick} style={{ ...style, }} className={`standard-text-color-dark ${className}`}>{title}</p>
    )
}

export function SubTextAtom({title, className, style, onClick}) {


    return(
        <p onClick={onClick} style={{ ...style, }} className={`standard-text-color-light ${className}`}>{title}</p>
    )
}